import { Component, OnInit, Input } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { AppService } from '../../shared/services/app.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { BaseService } from '../../shared/services/base.service';
import { StorageService } from '../../shared/services/storage.service';
import { LoaderService } from '../../services/loader.service';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'dhs-domain-platform',
    templateUrl: './domain-platform.component.html',
    styleUrls: ['./domain-platform.component.scss'],
    standalone: false
})
export class DomainPlatformComponent implements OnInit {
  @Input() domainPlatformList: any;
  @Input() domainPlatformListGroup: any={};
  appLoaded: boolean = false;

  constructor(
    public appService: AppService,
    public baseService: BaseService,
    public loader: LoaderService,
    private alertService: AlertsService,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    public utilService:UtilService
  ) { }

  ngOnInit(): void {
    if(this.domainPlatformList != undefined && Array.isArray(this.domainPlatformList) && this.domainPlatformList.length>0){
      for (let index = 0; index < this.domainPlatformList.length; index++) {
        const element = this.domainPlatformList[index];
          if(element.group != undefined && element.order != undefined){
            if(this.domainPlatformListGroup[element.group] == undefined){
              this.domainPlatformListGroup[element.group] = [];
            }
            this.domainPlatformListGroup[element.group].push(element);
          }
      }

      for(let key in this.domainPlatformListGroup){
        this.domainPlatformListGroup[key] =  this.domainPlatformListGroup[key].sort((a, b) => a.order - b.order);
      }
      this.appLoaded = true;
    }

  }

  openDomainPlatformApp(domainPlatform, refresh = true) {
    if(domainPlatform.key == this.appService._curApp){
      return;
    }else {
      if(domainPlatform.key == 'radis'){
        var url = domainPlatform.url;
        this.loader.showSpinner();
        this.baseService.get("GET_CONFIG", "module_code:system_config,config_code:RADIS_URL", "facility_config_mapping", "facility-management").subscribe(
          (data: any) => {
            this.loader.hideSpinner();
            if (data.errCode == -1) {
              this.alertService.error('Not able to set Super App');
            } else {
              if (data.resource != undefined && data.resource.length) {
                 if(data.resource[0].config_value != undefined && data.resource[0].config_value != "0"){
                  url = data.resource[0].config_value;
                 }
              }
              if(url != undefined && url != "" && domainPlatform.url.indexOf("http")>-1){
                //external url
                this.baseService.redirect(url).then(() => { });
              }else{
                  var newUrl = this.getFullDomainURL()+"/"+url;
                  this.baseService.redirect(newUrl).then(() => { });
              }
            }
          }, error => {
            console.log(error);
            this.loader.hideSpinner();
            this.alertService.error('API error');
          });
      }else{
        if(domainPlatform.url != undefined && domainPlatform.url != "" && domainPlatform.url.indexOf("http")>-1){
          this.baseService.redirect(domainPlatform.url).then(() => { });
        }else{
        this.loader.showSpinner();
        this.baseService.add({ super_app_context_key: domainPlatform.key }, 'change_superapp_event', true, this.appService._appData.DEFAULT_APPLICATION).subscribe(
          (data: any) => {
            this.loader.hideSpinner();
            if (data.errCode == -1) {
              this.alertService.error('Not able to set Super App');
            } else {
              if (data.resource != undefined && data.resource.length) {
                  window.location.href = window.location.origin;
                  this.storageService.reloadOtherTab();
                  this.appService.setRole(null);
                  // var dt = data.resource[0];
                  // var user = this.authenticationService.getCurrentUser();
                  // if(user != null){
                  //   user.role =  dt.role;
                  //   user.user_type = dt.user_type;
                  //   user.role_type = dt.role_type? dt.role_type: "";
                  //   this.authenticationService.setUser(user);
                  //   this.appService.setRole(user);
                  // }
               
              } else {
                this.alertService.error(data.message);
              }
            }
          }, error => {
            console.log(error);
            this.loader.hideSpinner();
            this.alertService.error('API error');
          });
        }
      }
      
    }
  }

  getFullDomainURL(){
    return window.location.origin;
  }
}
